function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) {
        return Array.from(iter);
    }
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import z from 'zod';
import { MenuLocation } from '@stereoagency/constants';
import { defineDocument } from 'sanity-typed-queries';
import menuItem from '../objects/menuItem.js';
import arrayEntry from '../fragments/arrayEntry.js';
var schema = defineDocument('menu', {
    location: {
        title: 'Location',
        type: 'string',
        options: {
            list: Object.values(MenuLocation)
        }
    },
    menuItems: {
        title: 'Menu Items',
        type: 'array',
        of: [
            {
                type: 'menuItem'
            }
        ]
    },
    language: {
        title: 'Language',
        type: 'string',
        readOnly: true,
        description: 'Use the "translations" menu to assign a language',
        validation: function validation(Rule) {
            return Rule.required();
        }
    }
}, [
    menuItem.schema.menuItem
]);
var validator = z.object({
    location: z.enum([
        MenuLocation.PRIMARY
    ].concat(_to_consumable_array(Object.values(MenuLocation)))),
    menuItems: z.array(menuItem.validator.merge(arrayEntry.validator))
}).partial();
schema.menu;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=menu.js.map